<app-main></app-main>
@if (isShowCookieConsent) {
  <app-cookie-consent (accept)="onAcceptConsent()"></app-cookie-consent>
}
